module.exports = __webpack_public_path__ + "img/contactUs@2x.b3e13f84.png";